import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";

class DropoffRecoveryJourneyElement extends HTMLElement {
  constructor() {
    super();
    this._root = null;
  }

  connectedCallback() {
    if (this._root) return;

    const routeMap = this.getAttribute("route-map");
    this._root = createRoot(this);
    this._root.render(<App routeMap={routeMap} />);
  }

  disconnectedCallback() {
    if (!this._root) return;
    this._root.unmount();
    this._root = null;
  }
}

const ELEMENT_NAME = "inlic-common-dropoff-journey-recovery";
if (!customElements.get(ELEMENT_NAME)) {
  customElements.define(ELEMENT_NAME, DropoffRecoveryJourneyElement);
}
